// C:\Users\purplehat\Desktop\payment-cookie-system\frontend\src\components\Login.js

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { ArrowLeftIcon, EnvelopeIcon } from '@heroicons/react/24/outline';
import api from '../services/api';

function Login({ setAuth }) {
  // 'login' | 'register' | 'forgot'
  const [mode, setMode] = useState('login');
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    username: '',
    email: '',
    password: ''
  });
  const [forgotEmail, setForgotEmail] = useState('');
  const [forgotSent, setForgotSent] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      let response;

      if (mode === 'login') {
        response = await api.post('/auth/login', {
          email: formData.email,
          password: formData.password
        });
        toast.success('✅ Login exitoso!');
      } else if (mode === 'register') {
        response = await api.post('/auth/register', {
          username: formData.username || formData.name,
          email: formData.email,
          password: formData.password
        });
        toast.success('✅ Cuenta creada! Ahora inicia sesión');
        setMode('login');
        setLoading(false);
        return;
      }

      // Guardar token y usuario
      const { token, user } = response.data;
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

      setAuth(true, user);
      navigate('/');

    } catch (error) {
      console.error('Error:', error);
      toast.error(error.response?.data?.error || 'Error en la autenticación');
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    if (!forgotEmail.trim()) {
      toast.error('Ingresa tu email');
      return;
    }
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email: forgotEmail.trim() });
      setForgotSent(true);
      toast.success('📧 Si el email existe, recibirás instrucciones');
    } catch (error) {
      // Mostrar el mismo mensaje por seguridad (no revelar si el email existe)
      setForgotSent(true);
      toast.success('📧 Si el email existe, recibirás instrucciones');
    } finally {
      setLoading(false);
    }
  };

  const resetToLogin = () => {
    setMode('login');
    setForgotEmail('');
    setForgotSent(false);
  };

  const inputStyle = {
    width: '100%',
    padding: '0.75rem',
    background: '#1a1a1a',
    border: '1px solid #333333',
    borderRadius: '0.5rem',
    color: '#ffffff',
    fontSize: '1rem'
  };

  const labelStyle = {
    color: '#9ca3af',
    fontSize: '0.875rem',
    display: 'block',
    marginBottom: '0.25rem'
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #000000, #1a1a1a)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '1rem'
    }}>
      <div style={{
        background: '#111111',
        border: '1px solid #00ffff',
        borderRadius: '1.5rem',
        padding: '2rem',
        width: '100%',
        maxWidth: '400px',
        boxShadow: '0 0 30px rgba(0,255,255,0.2)'
      }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <h1 style={{
            fontSize: '2rem',
            fontWeight: 'bold',
            background: 'linear-gradient(135deg, #00ffff, #ff00ff)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            marginBottom: '0.5rem'
          }}>
            The Black List
          </h1>
          <p style={{ color: '#9ca3af' }}>
            {mode === 'login' && 'Inicia sesión en tu cuenta'}
            {mode === 'register' && 'Crea una cuenta nueva'}
            {mode === 'forgot' && 'Recupera tu contraseña'}
          </p>
        </div>

        {/* ===== LOGIN / REGISTER ===== */}
        {mode !== 'forgot' && (
          <form onSubmit={handleSubmit}>
            {mode === 'register' && (
              <>
                <div style={{ marginBottom: '1rem' }}>
                  <label style={labelStyle}>Nombre completo</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    style={inputStyle}
                    placeholder="Juan Pérez"
                  />
                </div>

                <div style={{ marginBottom: '1rem' }}>
                  <label style={labelStyle}>Nombre de usuario</label>
                  <input
                    type="text"
                    name="username"
                    value={formData.username}
                    onChange={handleChange}
                    required
                    style={inputStyle}
                    placeholder="juan123"
                  />
                </div>
              </>
            )}

            <div style={{ marginBottom: '1rem' }}>
              <label style={labelStyle}>Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                style={inputStyle}
                placeholder="usuario@email.com"
              />
            </div>

            <div style={{ marginBottom: mode === 'login' ? '0.5rem' : '2rem' }}>
              <label style={labelStyle}>Contraseña</label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
                style={inputStyle}
                placeholder="••••••••"
              />
            </div>

            {/* ✅ Link "¿Olvidaste tu contraseña?" solo en login */}
            {mode === 'login' && (
              <div style={{ textAlign: 'right', marginBottom: '1.25rem' }}>
                <button
                  type="button"
                  onClick={() => { setMode('forgot'); setForgotSent(false); }}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: '#00ffff',
                    fontSize: '0.8rem',
                    cursor: 'pointer',
                    textDecoration: 'underline'
                  }}
                >
                  ¿Olvidaste tu contraseña?
                </button>
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%',
                padding: '1rem',
                background: 'linear-gradient(135deg, #00ffff, #ff00ff)',
                border: 'none',
                borderRadius: '0.5rem',
                color: '#000000',
                fontSize: '1rem',
                fontWeight: 'bold',
                cursor: loading ? 'not-allowed' : 'pointer',
                opacity: loading ? 0.5 : 1,
                marginBottom: '1rem'
              }}
            >
              {loading ? 'Procesando...' : (mode === 'login' ? 'Iniciar Sesión' : 'Registrarse')}
            </button>

            <button
              type="button"
              onClick={() => setMode(mode === 'login' ? 'register' : 'login')}
              style={{
                width: '100%',
                padding: '0.75rem',
                background: 'none',
                border: '1px solid #00ffff',
                borderRadius: '0.5rem',
                color: '#00ffff',
                fontSize: '0.875rem',
                cursor: 'pointer'
              }}
            >
              {mode === 'login' ? '¿No tienes cuenta? Regístrate' : '¿Ya tienes cuenta? Inicia sesión'}
            </button>
          </form>
        )}

        {/* ===== FORGOT PASSWORD ===== */}
        {mode === 'forgot' && (
          <div>
            {!forgotSent ? (
              <form onSubmit={handleForgotPassword}>
                <div style={{
                  background: '#00ffff10',
                  border: '1px solid #00ffff40',
                  borderRadius: '0.75rem',
                  padding: '0.85rem',
                  marginBottom: '1.25rem',
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '0.6rem'
                }}>
                  <EnvelopeIcon style={{ width: '1.1rem', color: '#00ffff', flexShrink: 0, marginTop: '0.1rem' }} />
                  <div style={{ fontSize: '0.78rem', color: '#9ca3af', lineHeight: 1.5 }}>
                    Ingresa el email asociado a tu cuenta y te enviaremos instrucciones para restablecer tu contraseña.
                  </div>
                </div>

                <div style={{ marginBottom: '1.25rem' }}>
                  <label style={labelStyle}>Email</label>
                  <input
                    type="email"
                    value={forgotEmail}
                    onChange={(e) => setForgotEmail(e.target.value)}
                    required
                    style={inputStyle}
                    placeholder="usuario@email.com"
                    autoFocus
                  />
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  style={{
                    width: '100%',
                    padding: '1rem',
                    background: 'linear-gradient(135deg, #00ffff, #ff00ff)',
                    border: 'none',
                    borderRadius: '0.5rem',
                    color: '#000000',
                    fontSize: '1rem',
                    fontWeight: 'bold',
                    cursor: loading ? 'not-allowed' : 'pointer',
                    opacity: loading ? 0.5 : 1,
                    marginBottom: '0.75rem'
                  }}
                >
                  {loading ? 'Enviando...' : 'Enviar instrucciones'}
                </button>

                <button
                  type="button"
                  onClick={resetToLogin}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    background: 'none',
                    border: '1px solid #333',
                    borderRadius: '0.5rem',
                    color: '#9ca3af',
                    fontSize: '0.875rem',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '0.4rem'
                  }}
                >
                  <ArrowLeftIcon style={{ width: '1rem' }} /> Volver al login
                </button>
              </form>
            ) : (
              <div style={{ textAlign: 'center' }}>
                <div style={{
                  width: '4rem',
                  height: '4rem',
                  borderRadius: '50%',
                  background: '#00ffff15',
                  border: '1px solid #00ffff40',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 1rem'
                }}>
                  <EnvelopeIcon style={{ width: '2rem', color: '#00ffff' }} />
                </div>
                <h3 style={{ color: '#fff', fontSize: '1.1rem', marginBottom: '0.5rem' }}>
                  Revisa tu correo
                </h3>
                <p style={{ color: '#9ca3af', fontSize: '0.85rem', lineHeight: 1.5, marginBottom: '1.5rem' }}>
                  Si <strong style={{ color: '#fff' }}>{forgotEmail}</strong> está registrado,
                  recibirás un email con las instrucciones para restablecer tu contraseña.
                  Revisa también tu carpeta de spam.
                </p>

                <button
                  onClick={resetToLogin}
                  style={{
                    width: '100%',
                    padding: '0.85rem',
                    background: 'linear-gradient(135deg, #00ffff, #ff00ff)',
                    border: 'none',
                    borderRadius: '0.5rem',
                    color: '#000',
                    fontWeight: 'bold',
                    fontSize: '0.9rem',
                    cursor: 'pointer'
                  }}
                >
                  Volver al login
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default Login;
